export default "__VITE_ASSET__B$ZOBFi3__"